var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/support.19b443a9.png","uri@2x": __webpack_public_path__ + "static/media/support.00708c48.png","uri@3x": __webpack_public_path__ + "static/media/support.cdf2a187.png",
    width: 42,
    height: 42
});